export default "__VITE_ASSET__BsIrAA$L__"